module.exports = __webpack_public_path__ + "static/img/angebot-mobil2.a61b012.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/angebot-mobil2.png
// module id = LlS+
// module chunks = 0